var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-area ajustaElColorDeFondo"},[_c('h1',[_vm._v("Hubo un error en el sistema")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.mensaje != null)?_c('h2',[_c('strong',[_vm._v("Mensaje")]),_vm._v(" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.mensaje)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5633a825","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comunes/Error500.vue
// module id = null
// module chunks = 